import React from 'react';
import { Pin, Nav, Info } from '@piiqtechnologies/svg-icons';
import '../../../../types/AccessDevice.js';
import '../../../../types/Analytics.js';
import '../../../../types/CASACommunity.js';
import '../../../../types/Community.js';
import '../../../../types/DxSettings.js';
import '../../../../types/MagicButton.js';
import '../../../../types/Pannellum.js';
import '../../../../types/Prospect.js';
import '../../../../types/ProspectIntelligence.js';
import { HotspotType } from '../../../../types/Space.js';
import '../../../../types/Tour.js';
import { PeekBox, PeekContainedIconButton, PeekTypography } from '@piiqtechnologies/ui-components';

const HotspotIcon = ({ type }) => {
    let icon = null;
    switch (type) {
        case HotspotType.Info: {
            icon = React.createElement(Info, null);
            break;
        }
        case HotspotType.Space: {
            icon = React.createElement(Nav, null);
            break;
        }
        case HotspotType.Node: {
            icon = React.createElement(Pin, null);
            break;
        }
        default: {
            icon = React.createElement(Pin, null);
        }
    }
    return icon;
};
const HotspotHighlightIcon = ({ type }) => {
    const buttonBackground = (type === HotspotType.Space && "common.purple") || "secondary.main";
    const shadowBackground = (type === HotspotType.Space && "common.opacityPurple") || "common.opacityTeal";
    const buttonSxProps = {
        backgroundColor: buttonBackground,
        ":hover": { backgroundColor: buttonBackground },
    };
    return (React.createElement(PeekBox, { sx: {
            backgroundColor: shadowBackground,
            mx: 0.5,
            width: 25,
            height: 25,
            borderRadius: "50%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        } },
        React.createElement(PeekContainedIconButton, { size: "small", sx: buttonSxProps, "aria-label": "hotspot" },
            React.createElement(PeekTypography, { color: "text.secondary", variant: "subtitle2" },
                React.createElement(HotspotIcon, { type: type })))));
};

export { HotspotHighlightIcon, HotspotIcon, HotspotIcon as default };
